import React from "react";

export const Footnote = props => {
  return props.footnoteText ? (
    <span style={{ padding: "5px", display: "inline-block", fontSize: "0.8em" }}>
      {props.footnoteText}
    </span>
  ) : null;
};
